
import Thumbnail from "@/components/Thumbnail";
import ToggleGame from "@/components/toggleGame";
import Drawer from 'vux/src/components/drawer/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


import ModalFrame from "./modalFrame";

import { mapState } from "vuex";
export default {
components: {
Thumbnail,
Drawer,

Flexbox,
FlexboxItem,
ToggleGame,
ModalFrame,
},
props: {
op88888: {
type: Boolean,
default: false,
},
},
data() {
return {
notSupportBGV: false,
videoIndex: 0,
showModal: false,
entryUrl: document.location.href,
scrollBox: null,
swiperItemIndex: 0,
noteActives: 0,
noticeList: [],
bannerList: [],
mode: false,
gameKindList: ["棋牌类", "电子游戏", "麻将类", "捕猎类"],
zhBanner: [
{
picUrl: "/static/image/moreyx_1.png",
className: "list1",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_2.png",
className: "list2",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_3.png",
className: "list3",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_4.png",
className: "list4",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_5.png",
className: "list1",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_6.png",
className: "list2",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_7.png",
className: "list3",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_8.png",
className: "list4",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_9.png",
className: "list3",
url: " https://api.gcpadi.com/api/trial",
},
{
picUrl: "/static/image/moreyx_10.png",
className: "list4",
url: " https://api.gcpadi.com/api/trial",
},
],
zhBannerImg: [
"/static/img/banner1.png",
"/static/img/banner2.png",
"/static/img/banner3.png",
"/static/img/banner4.png",
],
taiwanBannerImg: [
"/static/taiwan/banner1.png",
"/static/taiwan/banner2.png",
"/static/taiwan/banner3.png",
"/static/taiwan/banner4.png",
],
mobileImgList: [
"/static/m-img/banner1.png",
"/static/m-img/banner2.png",
"/static/m-img/banner3.png",
"/static/m-img/banner4.png",
],
taiwanMobileImgList: [
"/static/m-img/taiwan/banner1.png",
"/static/m-img/taiwan/banner2.png",
"/static/m-img/taiwan/banner3.png",
"/static/m-img/taiwan/banner4.png",
],
videoWebObj: {


video: require("@/assets/static/gameVideo/baisheng_1280X720.mp4"),
source: require("@/assets/static/gameVideo/baisheng_1280X720.mp4"),
},





};
},
computed: {
...mapState({
userInfo: (state) => state.user.userInfo,
isMobile: (state) => state.app.isMobile,
lang: (state) => state.app.lang,
}),
},
watch: {
isMobile(v) {
this.bannerChange();
},
lang(v) {
this.bannerChange();
},
},
created() {
const ua = String(window.navigator.userAgent).toLowerCase();

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)) {
this.notSupportBGV = true;
}
},
mounted() {
this.bannerChange();
window.onresize = () => {
if (window.innerWidth > 700) {
this.videoWebObj.video = require("@/assets/static/gameVideo/baisheng_1280X720.mp4");
this.videoWebObj.source = require("@/assets/static/gameVideo/baisheng_1280X720.mp4");

} else {
this.videoWebObj.video = require("@/assets/static/gameVideo/baisheng_640x360.mp4");
this.videoWebObj.source = require("@/assets/static/gameVideo/baisheng_640x360.mp4");
}
};
},
beforeDestroy() {},
methods: {
handleOpenGame(type) {







if (type === 1) {
window.open("https://api.gcpadi.com/api/trial");
} else {
window.open("https://api.gcpadi.com/api/trial");
}
},
handleModalFrameClick(bool, index) {
this.handleShowModal(bool, index);
},
handleShowModal(bool, index) {
this.showModal = bool;
this.videoIndex = index;
this.$store.dispatch("showHeader", false);
},
bannerChange() {
const isMobile = this.$store.state.app.isMobile;
const lang = this.$store.state.app.lang;
if (isMobile) {
switch (lang) {
case "zh-CN":
this.bannerList = this.mobileImgList;
break;
case "taiwan":
this.bannerList = this.taiwanMobileImgList;
break;
}
} else {
switch (lang) {
case "zh-CN":
this.bannerList = this.zhBannerImg;
break;
case "taiwan":
this.bannerList = this.taiwanBannerImg;
break;
}
}
},
},
};



// WEBPACK FOOTER //
// ./src/views/Home/index.vue